import {Component} from '@angular/core';
import {HostPage} from '../host/host';
import {BackgroundPage} from '../background/background';
import {CharacterPage} from '../character/character';
import {InvestigationPage} from '../investigation/investigation';
import {ResultsPage} from '../results/results';
import {DataService} from '../../data/data.ts';
import {CUSTOM_ICON_DIRECTIVES} from 'ionic2-custom-icons';
import * as firebase from 'firebase';
import { Tabs } from 'ionic-angular';
import { ViewChild, DoCheck } from '@angular/core';
import { AlertController } from 'ionic-angular';

@Component({
  templateUrl: 'build/pages/tabs/tabs.html',
    directives: [CUSTOM_ICON_DIRECTIVES]
})
export class TabsPage implements DoCheck {

  @ViewChild('myTabs') tabRef: Tabs;

  private tab1Root: any;
  private tab2Root: any;
  private tab3Root: any;
  private tab4Root: any;
  private tab5Root: any;
  private previousValue: Boolean;

  private dataService: DataService;

  constructor(private _data: DataService, public alertCtrl: AlertController) {
    this.dataService = _data;
    // this tells the tabs component which Pages
    // should be each tab's root Page
    this.previousValue = this.dataService.feedbackOpen;
    this.tab1Root = HostPage;
    this.tab2Root = BackgroundPage;
    this.tab3Root = CharacterPage;
    this.tab4Root = InvestigationPage;
    this.tab5Root = ResultsPage;

  }

  ionViewLoaded() {
  }

  ngDoCheck() {
    if(this.dataService.feedbackOpen == true && this.previousValue == false) {
      this.showFeedback()
    }
    if(this.dataService.feedbackOpen != this.previousValue){
      this.previousValue = this.dataService.feedbackOpen;
    }
  }

  showFeedback() {
    let confirm = this.alertCtrl.create({
      title: 'Please help us improve',
      message: 'Give us some quick feedback to help us improve and get 15% off your next game!',
      buttons: [
        {
          text: 'No Thanks',
          handler: () => {
          }
        },
        {
          text: 'Give Feedback',
          handler: () => {
            window.open('https://docs.google.com/forms/d/e/1FAIpQLSfZ9vO4lOX8kBe8iaCCjFQGZcbihpbCZ8LGMomW--LuAxl9Og/viewform', '_blank');
          }
        }
      ]
    });
    confirm.present();
  }

  onTabChanged(tab) {
   if (tab != undefined){
    switch (tab.tabTitle) {
       case "Character":
         this.dataService.characterBadge = "";
         break;
       case "Investigation":
         this.dataService.investigationBadge = "";
         break;
       case "Results":
         this.dataService.resultsBadge = "";
         break;
       case "Background":
         this.dataService.backgroundBadge = "";
         break;
       default:
         // code...
         break;
     } 
    }
  }
}
